import { runClientComponent } from '../../_common/client/client-component-runner';
import { BounceGateComponent } from './bounce-gate.component';

runClientComponent({ BounceGateComponent });
